import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { DocumentExpiryScreen } from '@/features/hr-reports/document-expiry-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/document-expiry')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: DocumentExpiryScreenRoute,
})

function DocumentExpiryScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <DocumentExpiryScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/document-expiry', search: next })}
    />
  )
}
